import { Nav, NavItem, NavList } from '@patternfly/react-core';
import _ from 'lodash';
import React from 'react';

const Navigation = ({ items, activeItem, onItemSelected }) => {
  return (<Nav theme={'light'}>
    <NavList>
      { _.map(items, (item, index) => {
        return (<NavItem
          preventDefault
          key={item}
          isActive={index === activeItem}
          onClick={() => onItemSelected(index)}
        >
          { item }
        </NavItem>);
      }) }
    </NavList>
  </Nav>);
};

export default React.memo(Navigation);
